import { gql, useMutation, useQuery } from '@apollo/client'

const GetSettingsQL = gql(`
  query GetSettings {
    getSettings {
      name
      enabled
      last_updated_by
      last_updated_timestamp
    }
  }
`)

const UpdateSettingMutationQL = gql(`
  mutation UpdateSetting($setting: UpdateSettingInput!) {
    updateSetting(setting: $setting) {
      name
      enabled
      last_updated_by
    }
  }
`)

export function GetSettings() {
  return useQuery(GetSettingsQL)
}

export function UpdateSettingQuery() {
  return useMutation(UpdateSettingMutationQL)
}
